import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/UserDeleteSkillButton';
// FOR ONE GRAPHQL QUERY
export const DELETE_USER_SKILL = defineAsyncActionTypes(`${prefix}/DELETE_USER_SKILL`);



// WEBPACK FOOTER //
// ./src/store/graphql/UserDeleteSkillButton/action-types.js